var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.agreement",
  title: "Control Preview: Agreement",
  description: "Read-only preview renderer for agreement controls.",
  fields: {
    "value": { title: "Value", type: "*", description: "Agreement data object." }
  }
});

var helper = require("./helpers/control.preview.js");

function readStatus(value) {
  if (typeof value === "boolean") {
    return { checked: value, agreedAt: "" };
  }

  if (value && typeof value === "object") {
    var checked = !!value.checked;
    var agreedAt = value.agreement || value.date || "";
    return {
      checked: checked,
      agreedAt: agreedAt ? String(agreedAt) : ""
    };
  }

  return { checked: false, agreedAt: "" };
}

exports.render = async function(options) {
  var status = readStatus(options.value);

  var lines = [status.checked ? "Accepted" : "Not accepted"];
  if (status.agreedAt) {
    lines.push("Recorded: " + status.agreedAt);
  }

  return helper.renderDoc({
    n: "div",
    c: "ua-control-preview-lines",
    i: lines.map(function(line) {
      return {
        n: "div",
        i: line
      };
    })
  });
};
